// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

<!-- Start DocsBotAI Widget + Custom Toggle Trigger -->
  // 1. De DocsBot Initialisatie (standaard code)
  window.DocsBotAI = window.DocsBotAI || {}, DocsBotAI.init = function(e) {
    return new Promise((t, r) => {
      var n = document.createElement("script");
      n.type = "text/javascript", n.async = !0, n.src = "https://widget.docsbot.ai/chat.js";
      let o = document.getElementsByTagName("script")[0];
      o.parentNode.insertBefore(n, o), n.addEventListener("load", () => {
        let n;
        Promise.all([new Promise((t, r) => {
          window.DocsBotAI.mount(Object.assign({}, e)).then(t).catch(r)
        }), (n = function e(t) {
          return new Promise(e => {
            if (document.querySelector(t)) return e(document.querySelector(t));
            let r = new MutationObserver(n => {
              if (document.querySelector(t)) return e(document.querySelector(t)), r.disconnect()
            });
            r.observe(document.body, {
              childList: !0,
              subtree: !0
            })
          })
        })("#docsbotai-root"), ]).then(() => t()).catch(r)
      }), n.addEventListener("error", e => {
        r(e.message)
      })
    })
  };

  DocsBotAI.init({
    id: "oE5L3I4Ul9SNOxvljR0t/JmceNRUHNhYQiJU4bX2p",
    options: {
      horizontalMargin: 0,
      verticalMargin: 100,
    }
  });

  // 2. De Custom Toggle Code voor jouw knop
  document.addEventListener("DOMContentLoaded", function() {
    const buttons = document.querySelectorAll('.multi-column__grid-item-button button');

    buttons.forEach(function(btn) {
      // Controleer of dit de juiste knop is
      if (btn.textContent.trim() === 'Chat with us') {
        
        btn.style.cursor = 'pointer';

        btn.addEventListener('click', function(e) {
          // Stop de foutmelding van het thema
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          console.log("Custom knop geklikt - DocsBot togglen...");

          // Logica om te wisselen tussen open/dicht
          if (window.DocsBotAI && typeof window.DocsBotAI.toggle === 'function') {
            // Als de officiële toggle functie bestaat, gebruik die
            window.DocsBotAI.toggle();
          } else {
            // FALLBACK: Als toggle() niet bestaat, simuleren we een klik op het chat-icoon rechtsonder.
            // Dit werkt altijd: als hij dicht is gaat hij open, als hij open is gaat hij dicht.
            const widgetRoot = document.querySelector('#docsbotai-root');
            if(widgetRoot) {
                // We proberen de specifieke button in de widget te vinden, anders klikken we op de container
                const launcher = widgetRoot.querySelector('button') || widgetRoot;
                launcher.click();
            }
          }
        });
      }
    });
  });
    document.addEventListener("DOMContentLoaded", function() {
    const button = document.querySelector('a[href="https://fietspechpas.nl/contact/formulier-aanvraag-service/"]');
    if (button) {
      button.setAttribute("target", "_blank");
      button.setAttribute("rel", "noopener");
    }
  });
<!-- End DocsBotAI Widget -->